import { gql } from '@apollo/client'

import { FRAGMENT_REGISTRATION_BASE } from '../fragments/registrationFragment'

export const CREATE_COUPON_ORDER_MUTATION = gql`
  mutation CreateCouponOrderPlacement(
    $input: createCouponOrderPlacementInput!
  ) {
    createCouponOrderPlacement(input: $input) {
      couponOrderPlacement {
        status
      }
    }
  }
`
